import { render, staticRenderFns } from "./SiloOverview.vue?vue&type=template&id=5db2ef2c&scoped=true&"
import script from "./SiloOverview.vue?vue&type=script&lang=ts&"
export * from "./SiloOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SiloOverview.vue?vue&type=style&index=0&id=5db2ef2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2ef2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serveradmin/azuredevopsagent3/_work/14/s/kbs.frontend/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db2ef2c')) {
      api.createRecord('5db2ef2c', component.options)
    } else {
      api.reload('5db2ef2c', component.options)
    }
    module.hot.accept("./SiloOverview.vue?vue&type=template&id=5db2ef2c&scoped=true&", function () {
      api.rerender('5db2ef2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SiloOverview.vue"
export default component.exports